import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./Login.scss";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
// import { getRegisterUser } from "../../Redux/Slices/user"
import {
  createUser,
  getLoggedInrUser,
  clearError,
  loginGoogleUser,
} from "../../Redux/slices/user";
import { useNavigate } from "react-router-dom";
import "../../Redux/slices/product.css";
import { Fragment } from "react";
import Loader from "../../Components/Loader/Loader";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSignUpMode, setIsSignUpMode] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");

  const { status, isAuthenticated, error } = useSelector((state) => state.user);
  const { isLoading } = useSelector((state) => state.app);

  const handleSocialLogin = (e) => {
    dispatch(loginGoogleUser());
  };

  const handleSignup = (e) => {
    e.preventDefault();
    if (password !== confirmpassword) {
      Swal.fire({
        icon: "error",
        title: "Password And Confirm Password Doesn't Matched",
      });
    } else {
      dispatch(
        createUser({
          name: userName,
          password,
          email,
        })
      );
    }
  };

  const handleSignIn = (e) => {
    e.preventDefault();

    dispatch(
      getLoggedInrUser({
        email: email,
        password,
      })
    );
  };

  useEffect(() => {
    if (status) {
      Swal.fire({
        timer: 1400,
        title: "Registered",
        // icon: "success",
      });

      setEmail("");
      setPassword("");
      setUserName("");
      dispatch(clearError());
    }
    if (isAuthenticated) {
      Swal.fire({
        timer: 1000,
        title: "Logged In",
        // icon: "success",
        showConfirmButton: false,
        position: "bottom-end",
        customClass: {
          popup: "custom-popup",
          closeButton: "custom-close-button",
          title: "s-title",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: true,
        closeButtonHtml: "&times;",
      });

      setEmail("");
      setPassword("");
      setUserName("");
      navigate("/");
      dispatch(clearError());
    }

    if (error) {
      Swal.fire({
        timer: 1500,
        title: error,
        icon: "error",
      });
      dispatch(clearError());
    }
  }, [status, isAuthenticated, error, dispatch, navigate]);

  const handleSignUpClick = () => {
    setIsSignUpMode(true);
  };

  const handleSignInClick = () => {
    setIsSignUpMode(false);
  };

  return (
    <Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={`container__login ${isSignUpMode ? "sign-up-mode" : ""}`}
        >
          <div className="forms-container">
            <div className="signin-signup">
              <form className="sign-in-form">
                <h2 className="title">Sign In</h2>
                <div className="input-fields">
                  <i className="fas fa-user"></i>
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="input-fields">
                  <i className="fas fa-lock"></i>
                  <input
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <Link to="/forgetPassword">
                  <p className="forgotten">Forgotton password ?</p>
                </Link>
                <button
                  type="submit"
                  className="btn_cart"
                  onClick={handleSignIn}
                >
                  Sign In
                </button>
                <p className="social-text">Or Sign In with social platforms</p>
                <div className="social-media">
                  <a href="#" className="social-icon">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a onClick={handleSocialLogin} className="social-icon">
                    <i className="fab fa-google"></i>
                  </a>
                </div>
              </form>

              <form action="#" className="sign-up-form">
                <h2 className="title">Sign Up</h2>
                <div className="input-fields">
                  <i className="fas fa-user"></i>
                  <input
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    name="Username"
                    placeholder="Username"
                  />
                </div>
                <div className="input-fields">
                  <i className="fas fa-envelope"></i>
                  <input
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                <div className="input-fields">
                  <i className="fas fa-lock"></i>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                  />
                </div>
                <div className="input-fields">
                  <i className="fas fa-lock"></i>
                  <input
                    type="password"
                    value={confirmpassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm Password"
                  />
                </div>
                <button
                  type="submit"
                  onClick={handleSignup}
                  className="btn_cart"
                >
                  Sign Up
                </button>

                <p className="social-text">Or Sign Up with social platforms</p>
                <div className="social-media">
                  <a href="#" className="social-icon">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#" className="social-icon">
                    <i className="fab fa-google"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>

          <div className="panels-container">
            <div className="panel left-panel">
              <div className="content">
                <h3>New here?</h3>
                <button
                  className="btn cart transparent"
                  id="sign-up-btn"
                  onClick={handleSignUpClick}
                >
                  Sign Up
                </button>
              </div>
            </div>

            <div className="panel right-panel">
              <div className="content">
                <h3>One of us?</h3>

                <button
                  className="btn cart transparent"
                  onClick={handleSignInClick}
                >
                  Sign In
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
export default Login;
